// Kundesidene i appen (lenkene kunden får på SMS og e-post, og Din side) og domenene som bare skal
// vise dem. Én liste, brukt av menylinjen (skjules), bunnteksten (PortalFooter) og vakten for
// butikkdomenene (App.js), så alle offentlige portalsider behandles likt.
// Plan: planer/din-side-merker-plan.md (M2).

export const KUNDESIDER = [
  /^\/svc\/[^/]+/,
  /^\/bookingportal\/[^/]+/,
  /^\/tilbud\/[^/]+/,
  /^\/kundeordre\/[^/]+/,
  /^\/kundetrykk\/[^/]+/,
  /^\/sykkel\/[^/]+/,
  /^\/chat\/[^/]+/,
  /^\/akutt\/[^/]+/,
  /^\/betal\/[^/]+/,
  /^\/min-side\/?$/,
];

export const erKundeside = (pathname = '') => KUNDESIDER.some((re) => re.test(String(pathname).toLowerCase()));

// Butikkenes domener for pristilbud (OFFER_PORTAL_BASE_* på Heroku). Samme Netlify-side som
// status.roykensykkelservice.no, men her skal bare kundesidene vises, ikke ansatt-appen.
// Logoen er den samme som i nettbutikken (rssport-nettbutikk/public/images/sport1.png).
export const SPORT1_LOGO = '/images/sport1.png';
export const KUNDEDOMENER = {
  'tilbud.sport1royken.no': { navn: 'Sport 1 Røyken', nettside: 'https://www.sport1royken.no', logo: SPORT1_LOGO },
  'tilbud.sport1slemmestad.no': { navn: 'Sport 1 Slemmestad', nettside: 'https://www.sport1slemmestad.no', logo: SPORT1_LOGO },
};

export const kundedomene = (host = typeof window !== 'undefined' ? window.location.hostname : '') =>
  KUNDEDOMENER[String(host).toLowerCase()] || null;
